const types = {
  RECOMMENDATION: "RECOMMENDATION",
  RECOMMENDATION_RESPONSE: "RECOMMENDATION_RESPONSE",
  RECOMMENDATION_CLEAR: "RECOMMENDATION_CLEAR",
};

export default types;
